import { call, put, takeLatest } from "redux-saga/effects";
import { ticketApi } from "../../../shared/components/Service";
import {
  MESSAGE_TEMPLATE_DELETE,
    MESSAGE_TEMPLATE_DELETE_API,
    MESSAGE_TEMPLATE_GET,
    MESSAGE_TEMPLATE_GET_API,
    MESSAGE_TEMPLATE_POST,
    MESSAGE_TEMPLATE_POST_API,
  MESSAGE_TEMPLATE_STATUS,
  MESSAGE_TEMPLATE_STATUS_API,
  MESSAGE_TEMPLATE_UPDATE_API,
  MESSAGE_TEMPLATES_LIST_GET_DATA,
  MESSAGE_TEMPLATES_LIST_GET_DETAIL_API
} from "./Constants";
import {
  setMessageTemplatesListSuccess,
  setMessageTemplatesListFail,
  setMessageTemplatePostSuccess,
  setMessageTemplatePostFail,
  loadMessageTemplatesList,
  deleteMessageTemplateSuccess,
  deleteMessageTemplateFail,
  changeMessageTemplateStatusSuccess,
  changeMessageTemplateStatusFail,
  getMessageTemplateByIdSuccess,
  getMessageTemplateByIdFail
} from "./Actions";
import { addErrorAlert, addSuccessAlert } from "../../alert/Actions";

function* getMessageTemplatesList() {
  try {
    const response = yield call(ticketApi.get,MESSAGE_TEMPLATES_LIST_GET_DETAIL_API,);
   if (response.status === 200 && response.data?.success) {
      yield put(
        setMessageTemplatesListSuccess(response.data.data)
      );
    } else {
      yield put(
        setMessageTemplatesListFail(response.data?.message || "Something went wrong")
      );
    }

  } catch (error) {
    yield put(setMessageTemplatesListFail(error.message || error));
  }
}

function* postMessageTemplateSaga({ request }) {
  try {
    const response = yield call(
      ticketApi.post,
      MESSAGE_TEMPLATE_POST_API,
      request
    );

    if (response.status === 200 && response.data?.success) {
      yield put(addSuccessAlert("Message Template Added Successfully"));
      yield put(setMessageTemplatePostSuccess(response.data));
       // REFRESH LIST (ONLY HERE)
      yield put(loadMessageTemplatesList());
    } else {
      yield put(
        addErrorAlert(response.data?.message || "Failed to add message template")
      );
      yield put(setMessageTemplatePostFail(response.data));
    }

  } catch (error) {
    yield put(addErrorAlert("Error adding message template"));
    yield put(setMessageTemplatePostFail(error));
  }
}

function* updateMessageTemplateSaga({ id, request }) {
  try {
    const response = yield call(
      ticketApi.put, // or putRequest if you have it
      `${MESSAGE_TEMPLATE_UPDATE_API}/${id}`,
      request
    );

    if (response.status === 200 && response.data?.success) {
      yield put(addSuccessAlert("Message Template Updated"));
      yield put(setMessageTemplatePostSuccess(response.data));
      yield put(loadMessageTemplatesList());
    } else {
      yield put(setMessageTemplatePostFail(response.data));
    }
  } catch (error) {
    yield put(setMessageTemplatePostFail(error));
  }
}

/* ========= DELETE ========= */
function* deleteMessageTemplateSaga({ id }) {
  try {
    const response = yield call(ticketApi.delete, `${MESSAGE_TEMPLATE_UPDATE_API}/${id}`,);
    if (response.status === 200 && response.data?.success) {
    yield put(addSuccessAlert("Message Template Deleted"));
    yield put(deleteMessageTemplateSuccess(true));
        // refresh list
    yield put(loadMessageTemplatesList());
    }
  } catch (error) {
    yield put(addErrorAlert("Error deleting template"));
    yield put(deleteMessageTemplateFail(error));
  }
}

/* ========= STATUS ========= */
function* changeMessageTemplateStatusSaga({ id }) {
  try {
    const response = yield call(ticketApi.patch,`${MESSAGE_TEMPLATE_STATUS_API}/${id}/toggle-status`);
 if (response.status === 200 && response.data?.success) {
    yield put(addSuccessAlert("Status Updated"));
    yield put(changeMessageTemplateStatusSuccess(true));

    // refresh list
    yield put(loadMessageTemplatesList());
 }
  } catch (error) {
    yield put(addErrorAlert("Error updating status"));
    yield put(changeMessageTemplateStatusFail(error));
  }
}

function* getMessageTemplateByIdSaga({ id }) {
  try {
    const response = yield call(
      ticketApi.get,
      `${MESSAGE_TEMPLATE_GET_API}/${id}`
    );

    if (response.status === 200 && response.data?.success) {
      yield put(getMessageTemplateByIdSuccess(response.data.data));
    } else {
      yield put(getMessageTemplateByIdFail(response.data));
    }

  } catch (error) {
    yield put(getMessageTemplateByIdFail(error));
  }
}

export function* watchMessageTemplatesList() {
  yield takeLatest(
    MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_LOAD,
    getMessageTemplatesList
  );
   yield takeLatest(
    MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_LOAD,
    postMessageTemplateSaga
  );
    yield takeLatest(
    MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_UPDATE_LOAD,
    updateMessageTemplateSaga
  );
    yield takeLatest(
    MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_LOAD,
    deleteMessageTemplateSaga
  );

  yield takeLatest(
    MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_LOAD,
    changeMessageTemplateStatusSaga
  );
    yield takeLatest(
    MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_LOAD,
    getMessageTemplateByIdSaga
  );
}
